module.exports = __webpack_public_path__ + "static/img/anna.b40ec04.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/anna.png
// module id = 5MBu
// module chunks = 1